"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getPersonasFromReadWriteRecipientList(readWriteRecipientList) {
    var personaList = [];
    if (readWriteRecipientList) {
        personaList = readWriteRecipientList.map(function (obj) { return obj.persona; });
    }
    return personaList;
}
exports.default = getPersonasFromReadWriteRecipientList;
//# sourceMappingURL=getPersonasFromReadWriteRecipientList.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-recipient-common/lib/utils/getPersonasFromReadWriteRecipientList.js
// module id = 2667
// module chunks = 2 3 4 45 63